import { FC } from 'react';

// https://dev.to/
export const Email: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    role="img"
    aria-labelledby="ac86r3w0cenhab0l4qlluvqn1zrrua9y"
  >
    <title id="ac86r3w0cenhab0l4qlluvqn1zrrua9y">Email address</title>
    <path d="M3 3h18a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1zm9.06 8.683L5.648 6.238 4.353 7.762l7.72 6.555 7.581-6.56-1.308-1.513-6.285 5.439h-.001z"></path>
  </svg>
);

export default Email;
